/**
 * 自定义的把kml文件转换成json
 */
import axios from 'axios';
import gcoord from 'gcoord';
import xmldom from 'xmldom';

const DOMParser = xmldom.DOMParser;
const opacityReg = /^[a-z0-9]{6}00$/;
const typeTotal = {};

export default (url) => {
    // to do 之后注释掉
    url = require('../config/map/road.kml');

    return axios.get(url).then((result) => {
        const kml = new DOMParser().parseFromString(result);
        const placemarks = kml.getElementsByTagName('Placemark');
        const json = [];
        for(let i = 0; i < placemarks.length; i++) {
            getXmlPlacemark(placemarks[i], json);
        }
        return json;
    });
}

function getXmlPlacemark(dom, json) {
    let flag = false;
    const colors = dom.getElementsByTagName('color');
    for(let k = 0; k < colors.length; k++) {
        flag = flag || !opacityReg.test(nodeVal(colors[k]));
    }
    if (!flag) {
        return;
    }
    const obj = {};
    for(let j = 0; j < dom.childNodes.length; j++) {
        const item = dom.childNodes[j];
        switch(item.tagName) {
            case undefined:
                break;
            case 'name':
                obj.name = nodeVal(item);
                break;
            case 'Style':
                obj.style = getObj(item);
                break;
            case 'MultiGeometry':
                obj.geometry = getMultiGeometry(item);
                break;
            case 'description':
                obj.description = getObj(item);
                break;
            default:
                const geo = getObj(item);
                geo.type = item.tagName;
                obj.geometry = [geo];
                getTypeNum(geo.type);
                
        }
    };
    json.push(obj);
}

function getTypeNum(type) {
    if (typeTotal[type] === undefined) {
        typeTotal[type] = 0;
    }
    typeTotal[type]++;
}

function getMultiGeometry(dom) {
    const arr = [];
    for (let k = 0; k <dom.childNodes.length; k++) {
        const item = dom.childNodes[k];
        if (item.tagName) {
            const obj = getObj(item);
            obj.type = item.tagName;
            arr.push(obj);
            getTypeNum(obj.type);
        }
    }
    return arr;
}

function getObj(dom) {
    if (dom.childNodes.length === 1 && !dom.childNodes[0].tagName) {
        return nodeVal(dom.childNodes[0]);
    }
    const obj = {};
    for(let k = 0; k < dom.childNodes.length; k++) {
        const item = dom.childNodes[k];
        if (item.tagName === 'coordinates') {
            obj['coordinates'] = nodeVal(item).split(' ').filter(v => !!v).map(point => translate(point.split(',')));
        } else if (item.tagName) {
            obj[item.tagName] = getObj(item);
        }
    }
    return obj;
}

function nodeVal(x) {
    if (x && x.normalize) {
        x.normalize();
    }
    return (x && x.textContent) || "";
}

function translate(point) {
    return gcoord.transform(
        [point[0], point[1]],    // 经纬度坐标
        gcoord.WGS84,               // 当前坐标系
        gcoord.BD09                 // 目标坐标系
      );
}
